import Vue from 'vue';
import Vuebar from 'vuebar';

import VueCompositionApi, { provide } from '@vue/composition-api';
import { ApolloClients } from '@vue/apollo-composable';
import { plugin, useProjectTailwindColors } from '@ideavivat/vivat-2';
import { ObserveVisibility } from 'vue-observe-visibility';
import Highcharts from 'highcharts';
import Maps from 'highcharts/modules/map';

import VueApexCharts from 'vue-apexcharts';
import * as VueGoogleMaps from 'vue2-google-maps';

import StatsPanel from '@/components/Report/StatsPanel.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';
import CommonYearStartOfYearSelector from '@/components/CommonYearStartOfYearSelect.vue';
import CommonYearMonthSelector from '@/components/CommonYearMonthSelector.vue';
import CommonWrapYearMonthSelector from '@/components/Vivat/CommonWrapYearMonthSelector.vue';
import VivatChartJS from '@/components/Vivat/ChartJS.vue';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import { client, unauthorizeClient } from './useApollo';
import HasAbility from './components/HasAbility.vue';
import { toCommaFormat } from './utils';

Maps(Highcharts);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCAJ_BkM-5T3P4nr2b91wg5BfBGLQDhFdk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  // installComponents: true,
});

Vue.use(VueApexCharts);
Vue.use(plugin);
Vue.use(VueCompositionApi);
Vue.use(Vuebar);
Vue.directive('observe-visibility', ObserveVisibility);

Vue.component('apexchart', VueApexCharts);
Vue.component('HasAbility', HasAbility);
Vue.component('StatsPanel', StatsPanel);
Vue.component('SmallChartPanel', SmallChartPanel);
Vue.component('CommonYearStartOfYearSelector', CommonYearStartOfYearSelector);
Vue.component('CommonYearMonthSelector', CommonYearMonthSelector);
Vue.component('CommonWrapYearMonthSelector', CommonWrapYearMonthSelector);
Vue.component('VivatChartJS', VivatChartJS);

Vue.filter('currency', toCommaFormat);

(window as any).BUILD_NOTE = `${process.env.VUE_APP_BUILD_NOTE || '__VUE_APP_BUILD_NOTE__'}${(window as any).VIVAT_BUILD_NOTE || ''}`;
console.log('Build:', (window as any).BUILD_NOTE);

Vue.config.productionTip = false;

(window as any).Vue = Vue;

// Development // https://idea-vivat-dotify-front-develop.netlify.app/
if (process.env.NODE_ENV === 'development' && window.location.href.includes('develop.netlify.app')) {
  (window as any).__APOLLO_CLIENT__ = client;
  Vue.config.devtools = true;
}

// Staging // https://idea-vivat-dotify-front-staging.netlify.app/
// if (process.env.NODE_ENV !== 'development' && window.location.href.includes('staging.netlify.app')) {}

// Production // https://dotify.app/
// if (process.env.NODE_ENV !== 'development') {}

// Local with process.env.VUE_APP_LOCAL_METRIC_SERVICE
// if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_LOCAL_METRIC_SERVICE) {}

new Vue({
  setup() {
    provide(ApolloClients, {
      default: client,
      unauthorize: unauthorizeClient,
    });
    return {};
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
